/*
 *
 * Do not edit directly
 * Generated on Fri, 11 Jul 2025 22:14:40 GMT
 *
 */


const theme = {
  appearances: {
    purpose: {
      type: 'variant',
      values: [ 'offer', 'default', 'editorial', 'subtle' ]
    },
    wrap: { type: 'variant', values: [ true ] }
  },
  rules: [
    {
      if: { purpose: 'editorial' },
      tokens: {
        backgroundColor: '#676e73',
        curveAfterBackgroundColor: '#676e73',
        curveBackgroundColor: '#2c2e30'
      }
    },
    {
      if: { purpose: 'offer' },
      tokens: {
        gradient: {
          angle: 135,
          stops: [
            { color: '#4b286d', hint: 0.75, stop: 0 },
            { color: '#e53293', stop: 1 }
          ],
          type: 'linear'
        }
      }
    },
    {
      if: { wrap: true },
      tokens: { paddingLeft: 24, paddingRight: 24 }
    },
    {
      if: { purpose: 'subtle' },
      tokens: {
        backgroundColor: '#7c53a5',
        curveAfterBackgroundColor: '#7c53a5'
      }
    }
  ],
  tokens: {
    backgroundColor: '#613889',
    borderRadius: 4,
    borderRadiusBottomLeft: null,
    borderRadiusBottomRight: null,
    boxShadowColor: 'rgba(0, 0, 0, 0.1)',
    boxShadowPaddingBottom: 2,
    boxShadowPaddingLeft: 0,
    boxShadowPaddingRight: 2,
    boxShadowPaddingTop: 0,
    curveAfterBackgroundColor: '#613889',
    curveAfterHeight: 4,
    curveAfterRadius: 0,
    curveAfterWidth: 8,
    curveBackgroundColor: '#3f2a54',
    curveHeight: 10,
    curveMarginTop: 4,
    curveWidth: 8,
    fontColor: '#ffffff',
    fontName: 'HNforTELUSSA',
    fontSize: 12,
    fontWeight: '700',
    gradient: null,
    lineHeight: 1.33333333333,
    paddingBottom: 4,
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 4
  }
}
export default theme
